const TOTPMain = require("totp/TOTPMain");
const NavHistoryManager = require("navigation/BrowserNavigationHistory");
const postal = require("common/PubSub");
const SettingsPlugin = require("settings/SettingsPlugin");
const RootController = require("common/RootController");
const AboutPlugin = require("about/AboutPlugin");

// Add browser detection capabilities to client config
CudaLaunch.clientConfiguration.addExtension(require("client_config/BrowserLocaleDetector"));

postal.channel("RootController").subscribe("rootControllerLoaded", function() {
    CudaLaunch.controllers.RootController.addPreAuthMenu();
});

postal.channel("Configuration").subscribe("language", function() {
    window.location.reload();
});

$(document).on("loadappmodules", function() {
    new SettingsPlugin().start([]);
    new AboutPlugin().start();
});

$(document).on("mobileinit", function() {
    new NavHistoryManager();
});

$(document).on("appinit", function() {
    i18n.loadNamespace("web");
});

TOTPMain();